import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { ConfirmationDialogConfig, ConfirmationDialogData } from './confirmation-dialog-config';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Injectable()
export class ConfirmationDialogService {
  constructor(private dialog: MatDialog) {}

  public confirm(data: ConfirmationDialogData): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, new ConfirmationDialogConfig(data));
    return dialogRef.afterClosed();
  }

  public styledConfirm(confirmationDialogConfig: ConfirmationDialogConfig): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, confirmationDialogConfig);
    return dialogRef.afterClosed();
  }
}
